var _a, _b;
import auth from "@irati/auth";
import { Brand, Benefits, PromoMaterials, WelcomeEmail, Whitelist, Visibility, Values, Teams, Invite } from "@irati-web/tenantsetup/src/components/Steps";
export var SetupSteps;
(function (SetupSteps) {
    SetupSteps["BRAND"] = "onb:biz:set_brand";
    SetupSteps["BENEFITS"] = "onb:biz:add_benefits";
    SetupSteps["PERK_VIS"] = "onb:biz:set_perks_vis";
    SetupSteps["COMPANY_VALUES"] = "onb:biz:add_comp_vals";
    SetupSteps["PROMO_MATS"] = "onb:biz:view_promo_mats";
    SetupSteps["WHITELIST"] = "onb:biz:whitelist_domain";
    SetupSteps["WELCOME_EMAIL"] = "onb:biz:set_welcome_email";
    SetupSteps["CREATE_TEAMS"] = "onb:biz:create_teams";
    SetupSteps["INVITE"] = "onb:biz:invite_people";
})(SetupSteps || (SetupSteps = {}));
export var SetupSections;
(function (SetupSections) {
    SetupSections["CUSTOMISE"] = "CUSTOMISE";
    SetupSections["COMMUNICATE"] = "COMMUNICATE";
    SetupSections["INVITE"] = "INVITE";
})(SetupSections || (SetupSections = {}));
// A configuration to control the category of steps, this is fully controlled by the FE
export var sectionMapping = (_a = {},
    _a[SetupSections.CUSTOMISE] = [SetupSteps.BRAND, SetupSteps.BENEFITS, SetupSteps.PERK_VIS, SetupSteps.COMPANY_VALUES],
    _a[SetupSections.COMMUNICATE] = [SetupSteps.PROMO_MATS, SetupSteps.WHITELIST, SetupSteps.WELCOME_EMAIL],
    _a[SetupSections.INVITE] = [SetupSteps.CREATE_TEAMS, SetupSteps.INVITE],
    _a);
// Additional step data managed by the FE
var stepDetails = (_b = {},
    _b[SetupSteps.BRAND] = {
        order: 1,
        title: "setup_tenant.steps.brand.title",
        subTitle: "setup_tenant.steps.brand.subTitle",
        nestedPath: "/brand",
        stepComponent: Brand
    },
    _b[SetupSteps.BENEFITS] = {
        order: 2,
        title: "setup_tenant.steps.benefits.title",
        subTitle: "setup_tenant.steps.benefits.subTitle",
        nestedPath: "/benefits",
        stepComponent: Benefits
    },
    _b[SetupSteps.PERK_VIS] = {
        order: 3,
        title: "setup_tenant.steps.visibility.title",
        subTitle: "setup_tenant.steps.visibility.subTitle",
        nestedPath: "/perk-visibility",
        stepComponent: Visibility
    },
    _b[SetupSteps.COMPANY_VALUES] = {
        order: 4,
        title: "setup_tenant.steps.values.title",
        subTitle: "setup_tenant.steps.values.subTitle",
        nestedPath: "/values",
        stepComponent: Values,
        hideStep: function () { return !auth.apps("recognition"); }
    },
    _b[SetupSteps.PROMO_MATS] = {
        order: 5,
        title: "setup_tenant.steps.promo.title",
        subTitle: "setup_tenant.steps.promo.subTitle",
        nestedPath: "/promo",
        stepComponent: PromoMaterials
    },
    _b[SetupSteps.WHITELIST] = {
        order: 6,
        title: "setup_tenant.steps.whitelist.title",
        subTitle: "setup_tenant.steps.whitelist.subTitle",
        nestedPath: "/whitelist",
        stepComponent: Whitelist
    },
    _b[SetupSteps.WELCOME_EMAIL] = {
        order: 7,
        title: "setup_tenant.steps.welcomeEmail.title",
        subTitle: "setup_tenant.steps.welcomeEmail.subTitle",
        nestedPath: "/welcome-email",
        stepComponent: WelcomeEmail
    },
    _b[SetupSteps.CREATE_TEAMS] = {
        order: 8,
        title: "setup_tenant.steps.createTeams.title",
        subTitle: "setup_tenant.steps.createTeams.subTitle",
        nestedPath: "/teams",
        stepComponent: Teams
    },
    _b[SetupSteps.INVITE] = {
        order: 9,
        title: "setup_tenant.steps.invite.title",
        subTitle: "setup_tenant.steps.invite.subTitle",
        nestedPath: "/invite-employees",
        stepComponent: Invite
    },
    _b);
export default stepDetails;
